import { DEFAULT_RESIZE_TIME } from "@angular/cdk/scrolling";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
   })
export class TimezoneService {
    private DEFAULT_TIMEZONE: string = "GMT"

    getTimezoneFromClient(): string {
        const timeZone = this.getTimeZone();
        if (timeZone)
            return timeZone

        return this.DEFAULT_TIMEZONE;
    }

    private getTimeZone(): string {
        return Intl.DateTimeFormat().resolvedOptions().timeZone
    }
}